function renderYandexAds() {
  const blocks = document.querySelectorAll('.yandex-rtb');
  
  blocks.forEach((block, index) => {
    const blockId = block.dataset.yandexBlockId;
    
    if (!blockId) return;

    const renderId = `yandex_rtb_${index}_${Date.now()}`;

    block.innerHTML = `<div id="${renderId}"></div>`;
    
    window.yaContextCb.push(() => {
      Ya.Context.AdvManager.render({
        blockId: blockId,
        renderTo: renderId
      });
    });
  });
}

document.addEventListener('turbolinks:load', renderYandexAds);

document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('.yandex-rtb').forEach(block => {
    block.dataset.initialized = 'false';
    block.innerHTML = '';
  });
});
